import { render, staticRenderFns } from "./DocClients.vue?vue&type=template&id=de7a2cbe&"
import script from "./DocClients.vue?vue&type=script&lang=js&"
export * from "./DocClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports